import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { EditButton } from '../../Buttons/EditButton';
import { IconButton, Switch, TextField } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import CloseIcon from '@mui/icons-material/Close';
import { Dispatch, Ref, SetStateAction, useState } from 'react';

const isBooleanValue = (value: string) => {
  const normalized = value?.toLowerCase();
  return normalized === 'true' || normalized === 'false';
};

export const getCustomerSettingsColumns = (
  editingRowIdRef: any,
  handleEdit: (id: string, value: string) => void,
  handleSave: (id: string, value: string) => void,
  handleCancel: () => void,
  setEditingValue: Dispatch<SetStateAction<string>>,
  editingValueRef: any,
  handleToggle: (id: string, value: boolean) => void,
): GridColDef[] => {
  return [
    {
      field: 'metakey',
      headerName: 'Meta Key',
      flex: 1,
    },
    {
      field: 'metavalue',
      headerName: 'Meta Value',
      flex: 1,
      renderCell: (params: GridRenderCellParams) => {
        const isEditing = editingRowIdRef?.current === params.id.toString();

        if (isEditing) {
          return (
            <TextField
              defaultValue={params.row.metavalue}
              onChange={(e) => {
                setEditingValue(e.target.value);
              }}
              value={editingValueRef?.current}
              onKeyDown={(e) => e.stopPropagation()}
            />
          );
        }

        if (isBooleanValue(params.row.metavalue)) {
          return (
            <Switch
              checked={params.row.metavalue?.toLowerCase() === 'true'}
              onChange={(e) => handleToggle(params.id.toString(), e.target.checked)}
            />
          );
        }

        return params.row.metavalue;
      },
    },
    {
      field: 'actions',
      headerName: 'Actions',
      flex: 1,
      renderCell: (params: GridRenderCellParams) => {
        const isEditing = editingRowIdRef?.current === params.id.toString();

        if (isBooleanValue(params.row.metavalue)) {
          return null;
        }

        if (isEditing) {
          return (
            <>
              <IconButton
                onClick={() => handleSave(params.id.toString(), editingValueRef?.current)}
              >
                <SaveIcon />
              </IconButton>

              <IconButton
                onClick={() => {
                  handleCancel();
                }}
              >
                <CloseIcon />
              </IconButton>
            </>
          );
        }

        return (
          <>
            <EditButton
              onClick={() => {
                handleEdit(params.id.toString(), params.row.metavalue);
              }}
            />
          </>
        );
      },
    },
  ];
};
